module.exports = __webpack_public_path__ + "img/icon-arrow-triangle-shadow.00d2ee18.svg";